import React from 'react';

const Spinner = () => {
    return (
        <div className="spinner-border" role="status" style={{ color: '#000' }}>
            <span className="visually-hidden">Loading...</span>
        </div>
    );
};

export default Spinner;
